<template>
  <div :style="{ width: '100%' }">
    <button class="reevoo" @click="showModal = !showModal" type="button">
      <div class="reevoo-cont">
        <span class="reviews">
          {{ $t('reevoo.read') }} {{ count }} {{ $t('reevoo.reviews') }}
        </span>
        <div 
          class="reevoomark_product_score"
          :style="{ 'backgroundPosition': `${(-66 - (average - 1) * 660)}px 0`}">
        </div>
        <img
          alt="Reevoo"
          class="reevoomark-logo"
          :src="`${cdn}/images/ReevooFullLogo.png`"
        />
        <div class="reevoo_average_score hidden" :class="`reevoo_${productId}`">{{ average }}</div>
      </div>
    </button>
    <modal v-if="showModal"  @close="showModal = false">
      <div slot="body">
        <iframe :src="`https://mark.reevoo.com/reevoomark/en-GB/product?sku=ap-${reviewId != 0 ? reviewId : productId}&trkref=SPS`" />
      </div>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import mixins from "@/mixins";

export default {
  name: 'Reevoo',
  mixins: [mixins.globals],
  components: { Modal },
  props: {
    count: { type: Number, required: true },
    average: { required: true },
    productId: { type: Number, required: true },
    reviewId: { type: String, required: false },
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>